import React from 'react';
import styled from 'styled-components';
import ColorConstants from '../../constants/ColorConstants';
import DragAndDropIcon from './svgs/DragAndDropIcon';

const defaultProps = {
    arrowColor: ColorConstants['regal-blue'],
    className: '',
    height: '18px',
    width: '18px',
};

const DragAndDropIndicator = ({
    arrowColor, height, width, className,
}) => (
    <IconWrapper className={className}>
        <DragAndDropIcon
            backgroundColor={arrowColor}
            height={height}
            width={width}
        />
    </IconWrapper>
);

DragAndDropIndicator.defaultProps = defaultProps;

const IconWrapper = styled.div`
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    margin: 6px 8px 0 4px;
    padding: 0px;
    transition: color 150ms;
    width: 16px; 

    &:hover {
        opacity: 0.8;
    }
`;

export default DragAndDropIndicator;
